import React from 'react';
import Modal from "../../../src/component/modal/ModalTemplate";
import * as apiUtil from "../../util/apiUtil";
import Pagination from "../table/Pagination";
import Loading from "../loading/Loading";

class ImageSelectModal extends React.Component {
    constructor(props){
        super(props);

        this.setLoading = this.setLoading.bind(this);

        this.changePage = this.changePage.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

        this.choiceButton = this.choiceButton.bind(this);

        this.state={
            loading: false,

            selectedImageIndex: -1,
        }
    }// end constructor
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.props.isOpen !== nextProps.isOpen
            || this.state.selectedImageIndex !== nextState.selectedImageIndex
            || this.props.imageList !== nextProps.imageList
            || this.state.page !== nextState.page
        )
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.imageList !== this.props.imageList || prevProps.isOpen !== this.props.isOpen) {
            if (this.state.selectedImageIndex !== -1) this.setState({ selectedImageIndex: -1 });
        }
    }


    changePage (event, value) {
        const { handleChangePage } = this.props;
        this.setState({ selectedImageIndex: -1 });
        handleChangePage(value);
    }

    handleCheckboxChange(index) {
        this.setState({ selectedImageIndex: index });
    }

    async choiceButton(){
        const { SelfAction, changePreview, clearFile, index, MTYPE, imageList, choiceCallback} = this.props;
        const { selectedImageIndex } = this.state;
        if (!imageList[selectedImageIndex]) return;
        if(MTYPE === "RCS"){
            await SelfAction.setRcsInfoImgOrigId(imageList[selectedImageIndex].imgId, index)
            await SelfAction.setMmsFileOrigId(imageList[selectedImageIndex].imgId, 0);
        } else{
            await SelfAction.setMmsFileOrigId(imageList[selectedImageIndex].imgId, 0);
        }
        await clearFile();
        await changePreview(imageList[selectedImageIndex].imgUrl);

        const selectedImage = imageList[selectedImageIndex];
        if (choiceCallback) choiceCallback(selectedImage);
    }


    render() {
        const { loading, selectedImageIndex } = this.state;
        const { isOpen, isClose, MTYPE } = this.props;
        const { total, imageList, size, page } = this.props;
        const { changePage, handleCheckboxChange, choiceButton } = this;
        return (
            <Modal open={isOpen}
                   handleClose={isClose}
                   className={"react-full-modal container-xxl"}
                   modalTitle={`${MTYPE} 이미지 불러오기`}
                   overlayClassName="modal-overlay">
                <Loading loading={loading}/>
                <div className='modal-body' style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                    {/*여기서 api 요청을 보낼 예정입니다*/}
                    <div className="d-grid mb-2">
                        {imageList.map((image, index) => (
                            <div className="grid-item" key={image.uid}>
                                <div className="card border">
                                    <div className="card-header ellipsis-text">
                                        <input className="form-check-input me-2 pointer" type="checkbox"
                                            id={`checkbox-${index}`}
                                            checked={selectedImageIndex === index}
                                            onChange={() => handleCheckboxChange(index)}
                                        />
                                        <label htmlFor={`checkbox-${index}`} className="d-inline fs-5 pointer">{image.imgName}</label>
                                    </div>
                                    <div className="card-body">
                                        <img src={image.imgUrl} alt="이미지 사진"/>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <Pagination page = {page} total={total} sizePerPage={size} handleChange={changePage}/>
                <div className='modal-footer'>
                    <button className='btn btn-primary btn-md' onClick={()=>{
                        if(selectedImageIndex === -1){
                            alert("이미지를 선택하지 않으셨습니다!");
                        }else {
                            if(window.confirm("해당 이미지로 선택하시겠습니까?")) {
                                choiceButton().then(r => isClose());
                            }
                        }
                    }}>선택하기</button>
                </div>

            </Modal>
        )
    }
}

export default ImageSelectModal;
